import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, message } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider } from './contexts/AuthContext';
import './utils/request'; // 导入全局axios配置
import Login from './components/Auth/Login';
import InitAdmin from './components/Auth/InitAdmin';
import AdminDashboard from './components/Admin/Dashboard';
import SalesDashboard from './components/Sales/Dashboard';
import ProtectedRoute from './components/Common/ProtectedRoute';
import './App.css';

function App() {
  useEffect(() => {
    // 配置message的全局设置
    message.config({
      top: 60,
      duration: 3,
      maxCount: 3,
    });
  }, []);

  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/init-admin" element={<InitAdmin />} />
              <Route 
                path="/admin/*" 
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/sales/*" 
                element={
                  <ProtectedRoute allowedRoles={['sales']}>
                    <SalesDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
